import React, { useContext, useReducer } from "react";
// import axios from "axios";
import axios from "../../axiosinstance";
import DomainContext from "./DomainContext";
import DomainReducer from "./DomainReducer";
import {
  SET_PROJECTS,
  SET_DOMAINS,
  NEW_DOMAIN,
  NEW_DOMAIN_ERROR,
  FILTER_DOMAINS,
  EDIT_DOMAIN,
  FORM_DATA,
  FORM_ERROR,
} from "../types";

import LayoutContext from "../layout/LayoutContext";

const DomainState = (props) => {
  const default_new_domain = {
    project: "",
    name: "",
  };
  const default_new_domain_error = {
    name: "",
  };
  const default_form_data = {
    name: "",
  };
  const default_form_error = {
    name: "",
  };

  const initialState = {
    projects: null,
    domains: null,
    new_domain: default_new_domain,
    new_domain_error: default_new_domain_error,
    search_domain: "",
    domains_filtered: null,
    selected_index: null,
    selected_domain: null,
    form_data: default_form_data,
    form_error: default_form_error,
  };

  const [state, dispatch] = useReducer(DomainReducer, initialState);
  const { setLoading, setAlert } = useContext(LayoutContext);

  const setProjects = (data) => {
    dispatch({
      type: SET_PROJECTS,
      payload: data,
    });
  };

  const setDomains = (data) => {
    dispatch({
      type: SET_DOMAINS,
      payload: data,
    });
  };

  const setNewDomain = (data) => {
    dispatch({
      type: NEW_DOMAIN,
      payload: data,
    });
  };

  const setNewDomainError = (data) => {
    dispatch({
      type: NEW_DOMAIN_ERROR,
      payload: data,
    });
  };

  const filterDomains = (data) => {
    dispatch({
      type: FILTER_DOMAINS,
      payload: data,
    });
  };

  const editDomain = (index, domain) => {
    let form_data = default_form_data;

    if (domain) {
      form_data = {
        name: domain.name,
      };
    } else {
      setFormError(default_form_error);
    }

    setFormData(form_data);
    dispatch({
      type: EDIT_DOMAIN,
      payload: {
        index,
        domain,
      },
    });
  };

  const setFormData = (data) => {
    dispatch({
      type: FORM_DATA,
      payload: data,
    });
  };

  const setFormError = (data) => {
    dispatch({
      type: FORM_ERROR,
      payload: data,
    });
  };

  const createDomain = async () => {
    setLoading(true);

    try {
      await axios.post("/api/domain", state.new_domain);

      setAlert("Domain Added.", "success");
      setNewDomain(default_new_domain);
      setNewDomainError(default_new_domain_error);
    } catch (err) {
      setAlert(err.response.data.message, "error");
    }

    setLoading(false);
  };

  const verifyDomain = async (name) => {
    setLoading(true);

    try {
      await axios.post(`/api/domain/${name}/verify`);

      setAlert("Domain Refreshed.", "success");
    } catch (err) {
      setAlert(err.response.data.message, "error");
    }

    setLoading(false);
  };

  const updateDomain = async (changes) => {
    setLoading(true);

    if (!changes) {
      setAlert("No Changes Has Been Made.", "info");
    } else {
      try {
        // await axios.put(`/api/domain/${state.selected_domain.id}`, {
        //   form_data: state.form_data,
        // });

        // setAlert("Domain Saved.", "success");
        setAlert("Update Domain function is not supported yet.", "info");
      } catch (err) {
        setAlert(err.response.data.message, "error");
      }
    }

    setLoading(false);
  };

  const deleteDomain = async () => {
    setLoading(true);

    if (state.selected_domain) {
      // const project = state.selected_domain.projectId;
      const name = state.selected_domain.name;

      try {
        await axios.delete(`/api/domain/${name}`);

        setAlert("Domain Deleted.", "success");
      } catch (err) {
        setAlert(err.response.data.message, "error");
      }
    }

    setLoading(false);
  };

  return (
    <DomainContext.Provider
      value={{
        projects: state.projects,
        setProjects,
        domains: state.domains,
        setDomains,
        new_domain: state.new_domain,
        setNewDomain,
        new_domain_error: state.new_domain_error,
        setNewDomainError,
        search_domain: state.search_domain,
        domains_filtered: state.domains_filtered,
        filterDomains,
        selected_index: state.selected_index,
        selected_domain: state.selected_domain,
        editDomain,
        form_data: state.form_data,
        setFormData,
        form_error: state.form_error,
        setFormError,
        createDomain,
        verifyDomain,
        updateDomain,
        deleteDomain,
      }}
    >
      {props.children}{" "}
    </DomainContext.Provider>
  );
};

export default DomainState;
